module.exports = __webpack_public_path__ + "static/media/pokedexThumbnail.44ac8b9e.png";